<template>
  <div id="my_signature_outer">
    <div>
      <div id="signature_content" class="js-signature" ></div>
      <div class="menu-list">
        <el-button @click="restoreSignatureButtonClicked">重置签名</el-button>
        <el-button @click="signatureSuccessButtonClicked">完成</el-button>
      </div>
      <div class="iconfont close-button" @click="closeButtonClicked">&#xe639;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MySignature",

  data() {
    return {
      signChanged: false,
      isUploading: false,
    }
  },


  mounted() {
    this.openSignAction();
  },
  methods: {

    openSignAction() {
      let _this = this;
      if (window.requestAnimFrame) {
        let signature = $('#signature_content');
        let width = signature.width();
        let height = signature.height();

        signature.jqSignature({
          height,
          width,
          border: '1px solid #999',
          background: '#fff',
          lineColor: '#000',
          lineWidth: 5,
          autoFit: false,
        });

        signature.on("jq.signature.changed", function () {
          _this.signChanged = true;
        });
      } else {
        alert("请加载jq-signature.js");
      }
    },

    closeButtonClicked() {
      if (this.signChanged) {
        let _this = this;
        this.$confirm('您的签名尚未上传，确定退出吗？', '提示', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          _this.$emit('close');
        }).catch(() => {
          console.log('不退出');
        })
      } else {
        this.$emit('close');
      }
    },
    restoreSignatureButtonClicked() {
      if (this.signChanged) {
        $('#signature_content').jqSignature('clearCanvas');
        this.signChanged = false;
      }
    },

    signatureSuccessButtonClicked() {
      if (!this.signChanged) {
        this.$toast('您尚未签名！');
        return;
      }
      let signBase64 = $('#signature_content').jqSignature('getDataURL');
      let _this = this;
      this.uploadImage(signBase64, function (imageUrl) {
        _this.$emit('success', {
          signatureUrl: imageUrl
        });
      })
    },
    uploadImage(imageData, callBack) {
      if (this.isUploading) {
        return;
      }
      this.isUploading = true;
      let _this = this;
      this.$store.state.http.ajax.postImage(imageData, function (code, imagUrl) {
        _this.isUploading = false;
        if (code == 0) {
          callBack(imagUrl);
        } else {
          _this.$toast('上传失败！');
        }
      });
    }

  }
}
</script>

<style scoped>

  #my_signature_outer {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0, 0.3);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  #my_signature_outer > div {
    background-color: white;
    width: 100%;
    max-width: 800px;
    /*height: 80%;*/
    position: relative;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  #my_signature_outer .close-button {
    font-size: 2rem;
    position: absolute;
    right: 10px;
    top: 5px;
  }

  #my_signature_outer #signature_content {
    background-color: #eeeeee;
    max-width: 600px;
    width: 100%;
    height: 200px;
  }

  #my_signature_outer .menu-list {
    margin-top: 20px;
  }

  #my_signature_outer .menu-list .el-button:first-child {
    color: #666;
    border-color: #aaa;
    background-color: white;
  }

  #my_signature_outer .menu-list .el-button:last-child {
    color: #fc1a34;
    border-color: #fc1a34;
    background-color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/MySignature.vue